export const parseAmountValue = value => typeof value === 'string' ? Number(value.replace(/,/g, '')) : value;
